import Chart from './chart/Main.vue'
import GoogleMapLoader from './google-map-loader/Main.vue'
import Highlight from './highlight/Main.vue'
import Litepicker from './litepicker/Main.vue'
import Tippy from './tippy/Main.vue'
import TippyContent from './tippy-content/Main.vue'
import ErrorNotify from '@/global-components/toastify-notify/error-notify.vue'
import SuccessNotify from '@/global-components/toastify-notify/success-notify.vue'
import SuccessNotifyWithButtons from '@/global-components/toastify-notify/success-notify-with-buttons.vue'
import TomSelect from './tom-select/Main.vue'
import LoadingIcon from './loading-icon/Main.vue'
import TinySlider from './tiny-slider/Main.vue'
import CKEditor from './ckeditor/Main.vue'
import Dropzone from './dropzone/Main.vue'
import FullCalendar from './calendar/Main.vue'
import FullCalendarDraggable from './calendar/Draggable.vue'
import * as featherIcons from '@zhuowenli/vue-feather-icons'
import I18n from '@/global-components/i18n/i18n.vue'
import I18nFlags from '@/global-components/i18n/i18n-flags.vue'
import I18nToggle from '@/global-components/i18n/i18n-toggle.vue'
import AppButton from '@/global-components/button/AppButton.vue'
import toggleButton from '@/global-components/button/toggle-button.vue'
import ActionPrintButton from '@/global-components/actions-button/action-print-button.vue'
import ActionExportButton from '@/global-components/actions-button/action-export-button.vue'
import ActionToolbar from '@/global-components/action-toolbar.vue'
import TableFilter from '@/global-components/filters/table-filter.vue'
import VueTelInput from 'vue-tel-input'
import 'vue-tel-input/dist/vue-tel-input.css'
import EpicSpinners from './epic-spinners/Main.vue'
import EmptyPage from '@/global-components/empty-page.vue'
import ListItemImage from '@/global-components/list/list-item-image.vue'
import Pagination from '@/global-components/pagination/pagination.vue'
import ShowDateTime from '@/global-components/show-date-time.vue'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import Uploader from '@/global-components/uploader/uploader.vue'
import { Icon } from '@iconify/vue'

export default app => {
  app.component('Icon', Icon)
  app.component([ShowDateTime.name], ShowDateTime)
  app.component('Pagination', Pagination)
  app.component('Uploader', Uploader)
  app.component('v-select', vSelect)
  app.component([ListItemImage.name], ListItemImage)
  app.component([ActionToolbar.name], ActionToolbar)
  app.component([EmptyPage.name], EmptyPage)
  app.component('loading-spinner', EpicSpinners)
  app.component('TableFilter', TableFilter)
  app.component([toggleButton.name], toggleButton)
  app.component([ActionExportButton.name], ActionExportButton)
  app.component([ActionPrintButton.name], ActionPrintButton)
  app.component('AppButton', AppButton)
  app.component([I18n.name], I18n)
  app.component('I18nFlags', I18nFlags)
  app.component([I18nToggle.name], I18nToggle)
  app.component('Chart', Chart)
  app.component('GoogleMapLoader', GoogleMapLoader)
  app.component('Highlight', Highlight)
  app.component('Litepicker', Litepicker)
  app.component('Tippy', Tippy)
  app.component('TippyContent', TippyContent)
  app.component('ErrorNotify', ErrorNotify)
  app.component('SuccessNotify', SuccessNotify)
  app.component('SuccessNotifyWithButtons', SuccessNotifyWithButtons)
  app.component('TomSelect', TomSelect)
  app.component('LoadingIcon', LoadingIcon)
  app.component('TinySlider', TinySlider)
  app.component('Dropzone', Dropzone)
  app.component('CKEditor', CKEditor)
  app.component('FullCalendar', FullCalendar)
  app.component('FullCalendarDraggable', FullCalendarDraggable)
  app.use(VueTelInput)

  for (const [key, icon] of Object.entries(featherIcons)) {
    icon.props.size.default = '24'
    app.component(key, icon)
  }
}
